import { render, staticRenderFns } from "./vipShopList.vue?vue&type=template&id=6de424d2&scoped=true&"
import script from "./vipShopList.vue?vue&type=script&lang=js&"
export * from "./vipShopList.vue?vue&type=script&lang=js&"
import style0 from "./vipShopList.vue?vue&type=style&index=0&id=6de424d2&lang=scss&scoped=true&"
import style1 from "./vipShopList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de424d2",
  null
  
)

export default component.exports